import {Component} from '@angular/core';

@Component({
  selector: 'id37-friend-tile-container',
  templateUrl: './friend-tile-container.component.html',
  styleUrls: ['./friend-tile-container.component.scss']
})
export class FriendTileContainerComponent {
}
